module.exports = __webpack_public_path__ + "static/media/footer-asset1.bca78afd.svg";